<template>
  <!-- Мобильная шторка карточки точки - те же высоты и жесты, что у шторки
       маршрута (useDragSheet); открыта поверх неё, если выбран и маршрут. -->
  <div class="md:hidden absolute inset-x-0 bottom-0 z-40 pointer-events-none" data-point-sheet>
    <div
      class="absolute inset-x-1.5 bottom-1.5 bg-sheet rounded-md border border-border shadow-ink overflow-hidden pointer-events-auto flex flex-col"
      :class="!isDragging && 'transition-[height] duration-200 ease-out'"
      :style="{ height: sheetHeight + 'px' }"
      @pointerdown="onSheetPointerDown"
    >
      <div class="shrink-0 py-1.5 flex flex-col items-center select-none" style="touch-action: none" data-sheet-drag-handle>
        <div class="w-10 h-1 rounded-full bg-[hsl(var(--muted-foreground)/0.3)]" />
      </div>
      <PointCard
        ref="cardRef"
        class="flex-1 min-h-0"
        :id="pointId"
        compact
        @back="$emit('back')"
        @close="$emit('close')"
        @open-route="(id) => $emit('open-route', id)"
        @open-point="(id) => $emit('open-point', id)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import PointCard from "./PointCard.vue";
import { useDragSheet } from "../../composables/useDragSheet";

const props = defineProps<{ pointId: string }>();
defineEmits<{
  (e: "back"): void;
  (e: "close"): void;
  (e: "open-route", routeId: number): void;
  (e: "open-point", id: string): void;
}>();

const cardRef = ref<InstanceType<typeof PointCard> | null>(null);
const { sheetHeight, isDragging, onSheetPointerDown, collapse } = useDragSheet({
  compactHeight: computed(() => cardRef.value?.compactHeight ?? 0),
  headerHeight: computed(() => cardRef.value?.headerHeight ?? 0),
  resetKey: () => props.pointId,
});
// collapse - App.vue на map-interact (тап по пустой карте / её перетаскивание).
defineExpose({ collapse });
</script>
